export default __webpack_public_path__ + "static/media/range_shade.70f5703d.svg";